export const EventsFormTabs = {
    EVENT_INFO: 'event-info',
    REPLIES: 'replies',
}
